import { Card, token } from '@bynder/design-system';
import styled from 'styled-components';

export const DesignCardPlaceholder = styled(Card.IconPlaceholder)`
    & svg {
        fill: ${token.gray400a};
        width: ${token.spacing9};
    }
`;
